import React from "react";
import Layout from "../components/layout/Layout";
import BannerCTA from "../components/shared/BannerCTA";

const CookieSettings: React.FC = () => {
    return (
        <Layout>
            <div className="policy-header">
                <h1>Cookie Policy</h1>
                <p className="last-updated">Last Updated: January 2026</p>
            </div>
            
            <div className="policy-content-wrapper">
                <div className="policy-content">

                    <div className="policy-section">
                        <h3>1. INTRODUCTION</h3>
                                    <p>
                                        This Cookie Policy explains how Ventus Travel Ltd ("we", "us", or "our") uses cookies and similar technologies when you visit our website at www.ventustravel.co.uk (the "Website"). It explains what these technologies are and why we use them, as well as your rights to control our use of them.
                                    </p>
                                    <p>
                                        By continuing to use our Website, you are agreeing to our use of cookies as described in this Cookie Policy.
                                    </p>
                                </div>

                    <div className="policy-section">
                        <h3>2. WHAT ARE COOKIES?</h3>
                                    <p>
                                        Cookies are small text files that are stored on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and to provide information to the owners of the site.
                                    </p>
                                    <p>
                                        Cookies allow a website to recognise your device and remember information about your visit, such as your preferred language and other settings. This can make your next visit easier and the site more useful to you.
                                    </p>
                                    <p>
                                        Cookies can be "persistent" or "session" cookies. Persistent cookies remain on your device when you go offline, while session cookies are deleted as soon as you close your web browser.
                                    </p>
                                </div>

                    <div className="policy-section">
                        <h3>3. WHY WE USE COOKIES</h3>
                        <p>We use cookies for several reasons:</p>
                        <ul>
                            <li><strong>Essential Website Function:</strong> Some cookies are required for our Website to operate. Without these cookies, services you have asked for cannot be provided.</li>
                            <li><strong>Performance and Analytics:</strong> These cookies help us understand how visitors interact with our Website by collecting and reporting information anonymously. This helps us improve the way our Website works.</li>
                            <li><strong>Functionality:</strong> These cookies enable the Website to provide enhanced functionality and personalisation, such as remembering your preferences.</li>
                            <li><strong>Marketing and Advertising:</strong> These cookies may be set through our Website by our advertising partners to build a profile of your interests and show you relevant adverts on other sites.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <h3>4. TYPES OF COOKIES WE USE</h3>
                        <p>The following table provides more information about the cookies we use and why:</p>
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead className="table-light">
                                    <tr>
                                        <th>Cookie Type</th>
                                        <th>Duration</th>
                                        <th>Purpose</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Strictly Necessary</td>
                                        <td>Session / Persistent</td>
                                        <td>Essential for the website to function. These cannot be switched off in our systems.</td>
                                    </tr>
                                    <tr>
                                        <td>Performance / Analytics</td>
                                        <td>Up to 2 years</td>
                                        <td>Help us understand how visitors use our website by collecting anonymous statistical information.</td>
                                    </tr>
                                    <tr>
                                        <td>Functional</td>
                                        <td>Up to 1 year</td>
                                        <td>Remember your preferences and provide enhanced, personalised features.</td>
                                    </tr>
                                    <tr>
                                        <td>Marketing / Targeting</td>
                                        <td>Up to 2 years</td>
                                        <td>Used to deliver advertisements relevant to you and measure the effectiveness of advertising campaigns.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="policy-section">
                        <h3>5. THIRD-PARTY COOKIES</h3>
                        <p>
                            In addition to our own cookies, we may also use various third-party cookies to report usage statistics of the Website and deliver advertisements on and through the Website.
                        </p>
                        <p>These third parties may include:</p>
                        <ul>
                            <li><strong>Google Analytics:</strong> We use Google Analytics to help us understand how visitors use our Website. Google Analytics uses cookies to collect information about your use of the Website, including your IP address. This information is transmitted to and stored by Google.</li>
                            <li><strong>Social Media Platforms:</strong> Our Website may include social media features, such as share buttons. These features may set cookies to enable the feature to function properly.</li>
                            <li><strong>Advertising Partners:</strong> We may work with advertising partners who use cookies to deliver relevant advertisements to you based on your interests.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <h3>6. HOW TO MANAGE COOKIES</h3>
                        <p>
                            You have the right to decide whether to accept or reject cookies. You can exercise your cookie preferences by clicking on the "Cookie Settings" link available on our Website.
                        </p>
                        <p>
                            You can also set or amend your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our Website though your access to some functionality and areas of our Website may be restricted.
                        </p>
                        <p>
                            <strong>Browser Controls:</strong> Most web browsers allow some control of cookies through browser settings. To find out more about cookies, including how to see what cookies have been set, visit <a href="https://www.aboutcookies.org" target="_blank" rel="noopener noreferrer">www.aboutcookies.org</a> or <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer">www.allaboutcookies.org</a>.
                        </p>
                        <p>Find out how to manage cookies on popular browsers:</p>
                        <ul>
                            <li><strong>Google Chrome:</strong> <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">support.google.com/chrome/answer/95647</a></li>
                            <li><strong>Microsoft Edge:</strong> <a href="https://support.microsoft.com/en-gb/microsoft-edge" target="_blank" rel="noopener noreferrer">support.microsoft.com/en-gb/microsoft-edge</a></li>
                            <li><strong>Mozilla Firefox:</strong> <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="noopener noreferrer">support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer</a></li>
                            <li><strong>Apple Safari:</strong> <a href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">support.apple.com/en-gb/guide/safari/sfri11471/mac</a></li>
                            <li><strong>Opera:</strong> <a href="https://help.opera.com/en/latest/web-preferences/" target="_blank" rel="noopener noreferrer">help.opera.com/en/latest/web-preferences/</a></li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <h3>7. DO NOT TRACK SIGNALS</h3>
                        <p>
                            Some browsers include a "Do Not Track" (DNT) feature that signals to websites that you do not want to have your online activity tracked. Currently, our Website does not respond to DNT signals. If a standard for responding to DNT signals is established, we may revisit our DNT policy.
                        </p>
                    </div>

                    <div className="policy-section">
                        <h3>8. CHANGES TO THIS COOKIE POLICY</h3>
                        <p>
                            We may update this Cookie Policy from time to time to reflect changes in technology, legislation, our business operations, or any other reason we determine is necessary or appropriate.
                        </p>
                        <p>
                            Any changes will become effective when we post the revised Cookie Policy on our Website. We encourage you to review this Cookie Policy periodically to stay informed about our use of cookies.
                        </p>
                    </div>

                    <div className="policy-section">
                        <h3>9. CONTACT US</h3>
                        <p>If you have any questions about our use of cookies or this Cookie Policy, please contact us via:</p>
                        <ul>
                            <li><strong>Website:</strong> <a href="https://www.ventustravel.co.uk" target="_blank" rel="noopener noreferrer">www.ventustravel.co.uk</a></li>
                            <li><strong>Contact Page:</strong> <a href="https://www.ventustravel.co.uk/contact-us" target="_blank" rel="noopener noreferrer">www.ventustravel.co.uk/contact-us</a></li>
                        </ul>
                    </div>

                </div>
            </div>
            <BannerCTA />
        </Layout>
    );
};

export default CookieSettings;
